var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 731,
    height: 732,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.378 -1.42514e-05C163.378 90 236.31 162.96 326.276 162.96C416.241 162.96 489.413 90 489.413 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.9 -1.4241e-05C156.9 82.8 229.832 150 319.798 150C409.763 150 482.695 82.8 482.695 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.423 -1.42514e-05C150.423 75.6 223.355 137.04 313.32 137.04C403.286 137.04 476.458 75.6 476.458 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.945 -1.4241e-05C143.945 68.4 216.877 123.84 306.843 123.84C396.808 123.84 469.74 68.4 469.74 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.228 -1.42514e-05C137.228 61.2 210.16 110.88 300.125 110.88C390.091 110.88 463.263 61.2 463.263 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.75 -1.42514e-05C130.75 54 203.682 97.92 293.648 97.92C383.613 97.92 456.785 54 456.785 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.273 -1.42514e-05C124.273 46.8 197.205 84.72 287.17 84.72C377.136 84.72 450.308 46.8 450.308 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.795 -1.42514e-05C117.795 39.6 190.727 71.76 280.693 71.76C370.658 71.76 443.83 39.6 443.83 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.318 -1.4241e-05C111.318 32.4 184.25 58.8 274.216 58.8C364.181 58.8 437.113 32.4 437.113 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.841 -1.4241e-05C104.841 25.2 177.773 45.6 267.738 45.6C357.704 45.6 430.636 25.2 430.636 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1231 -1.42514e-05C98.1231 18 171.055 32.64 261.021 32.64C350.986 32.64 424.158 18 424.158 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6456 -1.42514e-05C91.6456 10.8 164.578 19.68 254.543 19.68C344.509 19.68 417.681 10.8 417.681 0",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M326.516 0C326.516 90 253.584 162.96 163.618 162.96C73.6525 162.96 0.480529 90 0.480533 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M332.993 0C332.993 82.8 260.061 150 170.096 150C80.13 150 7.19792 82.8 7.19792 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M339.471 0C339.471 75.6 266.539 137.04 176.573 137.04C86.6075 137.04 13.4356 75.6 13.4356 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M345.948 0C345.948 68.4 273.016 123.84 183.051 123.84C93.0851 123.84 19.9131 68.4 19.9132 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M352.425 0C352.425 61.2 279.493 110.88 189.527 110.88C99.5617 110.88 26.3897 61.2 26.3897 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M358.902 0C358.902 54 285.97 97.92 196.005 97.92C106.039 97.92 33.1072 54 33.1072 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M365.62 0C365.62 46.8 292.688 84.72 202.723 84.72C112.757 84.72 39.585 46.8 39.585 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M372.098 0C372.098 39.6 299.166 71.76 209.2 71.76C119.235 71.76 46.0626 39.6 46.0626 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M378.575 0C378.575 32.4 305.643 58.8 215.678 58.8C125.712 58.8 52.78 32.4 52.78 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M385.053 0C385.053 25.2 312.121 45.6 222.155 45.6C132.19 45.6 59.2575 25.2 59.2575 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M391.53 0C391.53 18 318.598 32.64 228.633 32.64C138.667 32.64 65.4952 18 65.4952 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M398.008 0C398.008 10.8 325.076 19.68 235.11 19.68C145.145 19.68 72.2126 10.8 72.2126 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M404.726 0C404.726 3.6 331.794 6.48 241.828 6.47999C151.862 6.47999 78.6905 3.59999 78.6905 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1679 -1.3402e-05C85.1679 3.59999 158.1 6.47999 248.066 6.47999C310.202 6.48 364.181 5.04 391.771 3.12",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M652.311 0C652.311 90 579.378 162.96 489.413 162.96C399.447 162.96 326.515 90 326.515 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M659.028 0C659.028 82.8 585.856 150 495.891 150C405.925 150 332.993 82.8 332.993 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M665.506 0C665.506 75.6 592.574 137.04 502.608 137.04C412.643 137.04 339.471 75.6 339.471 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M671.982 0C671.982 68.4 599.05 123.84 509.085 123.84C419.119 123.84 345.947 68.4 345.947 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M678.46 0C678.46 61.2 605.528 110.88 515.562 110.88C425.597 110.88 352.425 61.2 352.425 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M684.938 0C684.937 54 612.005 97.92 522.04 97.92C432.074 97.92 358.902 54 358.902 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M691.415 0C691.415 46.8 618.483 84.72 528.517 84.72C438.552 84.72 365.62 46.8 365.62 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M698.133 0C698.133 39.6 625.201 71.76 535.235 71.76C445.27 71.76 372.098 39.6 372.098 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M704.61 0C704.61 32.4 631.678 58.8 541.473 58.8C451.267 58.8 378.575 32.4 378.575 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M711.088 0C711.088 25.2 638.156 45.6 548.19 45.6C458.225 45.6 385.293 25.2 385.293 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M717.565 0C717.565 18 644.633 32.64 554.668 32.64C464.702 32.64 391.53 18 391.53 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M724.043 0C724.043 10.8 651.111 19.68 561.145 19.68C471.18 19.68 398.008 10.8 398.008 -1.42514e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M730.521 0C730.521 3.6 657.588 6.48 567.623 6.47999C477.657 6.47999 404.725 3.59999 404.725 -1.4241e-05",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M411.203 -1.3402e-05C411.203 3.59999 484.135 6.47999 574.101 6.47999C636.237 6.48 690.216 5.04 717.806 3.12",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480345 164.16C90.4459 164.16 163.378 237.12 163.378 327.12C163.378 417.12 90.4459 490.08 0.480331 490.08",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0.48029 157.681C83.2486 157.681 150.423 230.641 150.423 320.641C150.423 410.641 83.2486 483.601 0.480275 483.601",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480234 151.2C76.0513 151.2 137.468 224.16 137.468 314.16C137.468 404.16 76.0513 477.12 0.48022 477.12",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479855 144.48C68.8537 144.48 124.272 217.44 124.272 307.44C124.272 397.441 68.8537 470.4 0.479841 470.4",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480799 138C61.6574 138 111.318 210.96 111.318 300.96C111.318 390.96 61.6573 463.92 0.480785 463.92",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480806 131.521C54.4601 131.521 98.3633 204.48 98.3633 294.48C98.3633 384.481 54.4601 457.441 0.480792 457.441",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480447 125.04C47.2625 125.04 85.168 198 85.168 288C85.168 378 47.2625 451.2 0.480433 451.2",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480384 118.561C40.0652 118.561 72.2129 191.521 72.2129 281.521C72.2129 371.521 40.0652 444.48 0.480369 444.48",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480328 111.841C32.8679 111.841 59.2578 184.801 59.2578 274.801C59.2578 364.801 32.8679 437.761 0.480314 437.761",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479961 105.36C25.6703 105.36 46.0625 178.32 46.0625 268.32C46.0625 358.32 25.6703 431.28 0.479947 431.28",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479906 98.8809C18.473 98.8809 33.1074 171.841 33.1074 261.841C33.1074 351.841 18.473 424.801 0.479891 424.801",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480827 92.4004C11.2767 92.4004 20.1533 165.36 20.1533 255.36C20.1533 345.36 11.2767 418.32 0.480813 418.32",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480331 327.12C90.4459 327.12 163.378 254.16 163.378 164.16C163.378 74.16 90.4459 0.959958 0.480345 0.959954",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480275 333.6C83.2486 333.6 150.423 260.64 150.423 170.64C150.423 80.6397 83.2486 7.67968 0.48029 7.67968",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0.48022 340.32C76.0513 340.32 137.468 267.36 137.468 177.36C137.468 87.3602 76.0513 14.1602 0.480234 14.1602",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479841 346.8C68.8537 346.8 124.272 273.84 124.272 183.84C124.272 93.8397 68.8537 20.6396 0.479855 20.6396",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480785 353.28C61.6573 353.28 111.318 280.32 111.318 190.32C111.318 100.32 61.6574 27.1201 0.480799 27.1201",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480792 359.76C54.4601 359.76 98.3633 286.8 98.3633 196.8C98.3633 106.8 54.4601 33.5996 0.480806 33.5996",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480433 366.24C47.2625 366.24 85.168 293.28 85.168 203.28C85.168 113.28 47.2625 40.3203 0.480447 40.3203",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480369 372.96C40.0652 372.96 72.2129 300 72.2129 210C72.2129 120 40.0652 46.7998 0.480384 46.7998",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480314 379.44C32.8679 379.44 59.2578 306.48 59.2578 216.48C59.2578 126.48 32.8679 53.5195 0.480328 53.5195",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479947 385.92C25.6703 385.92 46.0625 312.96 46.0625 222.96C46.0625 132.96 25.6703 60 0.479961 60",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479891 392.4C18.473 392.4 33.1074 319.439 33.1074 229.439C33.1074 139.439 18.473 66.4795 0.479906 66.4795",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480813 398.88C11.2767 398.88 20.1533 325.92 20.1533 235.92C20.1533 145.92 11.2767 72.96 0.480827 72.96",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480446 405.36C4.07907 405.36 6.958 332.4 6.958 242.4C6.958 152.4 4.07908 79.4404 0.48046 79.4404",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0.48046 85.9199C4.07908 85.9199 6.958 158.88 6.958 248.88C6.958 311.04 5.51849 365.04 3.59922 392.64",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480331 653.28C90.4459 653.28 163.378 580.32 163.378 490.32C163.378 400.32 90.4459 327.36 0.480345 327.36",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480275 659.761C83.2486 659.761 150.423 586.801 150.423 496.801C150.423 406.801 83.2486 333.601 0.48029 333.601",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0.48022 666.481C76.0513 666.481 137.468 593.521 137.468 503.521C137.468 413.521 76.0513 340.561 0.480234 340.561",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479841 672.96C68.8537 672.96 124.272 600 124.272 510C124.272 420 68.8537 347.04 0.479855 347.04",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480785 679.441C61.6573 679.441 111.318 606.481 111.318 516.48C111.318 426.48 61.6574 353.521 0.480799 353.521",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480792 685.92C54.4601 685.92 98.3633 612.96 98.3633 522.96C98.3633 432.96 54.4601 360 0.480806 360",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480433 692.4C47.2625 692.4 85.168 619.441 85.168 529.44C85.168 439.44 47.2625 366.48 0.480447 366.48",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480369 698.88C40.0652 698.88 72.2129 625.92 72.2129 535.92C72.2129 445.92 40.0652 372.96 0.480384 372.96",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480314 705.601C32.8679 705.601 59.2578 632.641 59.2578 542.641C59.2578 452.641 32.8679 379.681 0.480328 379.681",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479947 712.08C25.6703 712.08 46.0625 639.12 46.0625 549.12C46.0625 459.12 25.6703 386.16 0.479961 386.16",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0.479891 718.561C18.473 718.561 33.1074 645.601 33.1074 555.601C33.1074 465.601 18.473 392.641 0.479906 392.641",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480813 725.04C11.2767 725.04 20.1533 652.08 20.1533 562.08C20.1533 472.08 11.2767 399.12 0.480827 399.12",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0.480446 731.521C4.07907 731.521 6.958 658.561 6.958 568.561C6.958 478.561 4.07908 405.601 0.48046 405.601",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0.48046 412.08C4.07908 412.08 6.958 485.04 6.958 575.04C6.958 637.2 5.51849 691.2 3.59922 718.8",
    strokeOpacity: 0.25,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLeft);
export default __webpack_public_path__ + "static/media/landing-left.e379fec470a3a0bbcc62e6bc286ae26d.svg";
export { ForwardRef as ReactComponent };